import { createContext, useContext } from 'react';
import { SubscriptionConsentContextType } from './type';

export const SubscriptionConsentContext = createContext({} as SubscriptionConsentContextType);

export const useSubscriptionConsentContext = () => {
  const context = useContext(SubscriptionConsentContext);
  if (!context) {
    throw new Error('useSubscriptionConsentContext must be used within a SubscriptionConsentProvider');
  }
  return context;
};
